export default "__VITE_ASSET__BWZZRvVj__"